import React from 'react';
import { Card, CardContent, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    minWidth: '400px',
    padding: '10px 20px',
  },
  content: {
    '& p:not(:last-child)': {
      marginBottom: '16px',
    },
    '& h6': {
      fontSize: '16px',
    },
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
});


const FileProcessInfo: React.FC = () => {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardContent className={classes.content}>
        <Typography variant="h4">
          Hello!
        </Typography>
        <Typography>
          It's important to us to ensure that images associated with offers adhere to our community guidelines.
        </Typography>
        <Typography>
          We will review what you have uploaded and if there are no issues, we will mark your offer 'approved' and send you an email letting you know it's read to be activated.
        </Typography>
        <Typography variant="h2">
          Thank you!
        </Typography>

      </CardContent>
    </Card>
  );
};

export default FileProcessInfo;
